"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const UI_1 = require("~/components/UI");
const consts_1 = require("~/store/consts");
const consts_2 = require("~/consts/consts");
const useWindowDimensions_1 = __importDefault(require("~/hooks/useWindowDimensions"));
const ShortcutItem_1 = __importDefault(require("./ShortcutItem"));
const ShortcutsWidget_scss_1 = __importDefault(require("./ShortcutsWidget.scss"));
function ShortcutsWidget() {
    const { t } = (0, react_i18next_1.useTranslation)('widgets');
    const shortcutComponents = consts_2.SHORTCUTS.map((shortcut) => {
        return react_1.default.createElement(ShortcutItem_1.default, { name: shortcut.name, value: shortcut.value, key: shortcut.name });
    });
    const { width } = (0, useWindowDimensions_1.default)();
    return (react_1.default.createElement(UI_1.Widget, { widgetName: consts_1.WIDGETS.SHORTCUTS_WIDGET, defaultSize: {
            width: 336,
            height: 460,
        }, minSize: {
            width: 336,
            height: 355,
        }, defaultPosition: {
            // 424 = 336 widget's width; 72 - margin right, 16 - boundaries margin left
            x: width - 424,
            y: 61,
        } },
        react_1.default.createElement("div", { className: ShortcutsWidget_scss_1.default.widget },
            react_1.default.createElement("header", null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: ShortcutsWidget_scss_1.default.title }, t('shortcuts.header')))),
            react_1.default.createElement("main", null,
                react_1.default.createElement("div", null, shortcutComponents)))));
}
exports.default = ShortcutsWidget;
